import { useIntl } from 'react-intl';
import { toast } from 'sonner';
import { useCallback } from 'react';
import { createTestIdToasterMessage } from 'utils/createTestIdToasterMessage';

export function useDownloadProgress() {
  const intl = useIntl();

  const withDownloadProgress = useCallback(
    <T>(downloadFn: () => Promise<T>): Promise<T> => {
      const promise = downloadFn();

      toast.promise(promise, {
        loading: createTestIdToasterMessage(
          intl.formatMessage({
            id: 'articleVisibility.export.progress',
          }),
          'toaster-loading'
        ),
        success: () =>
          createTestIdToasterMessage(
            intl.formatMessage({
              id: 'articleVisibility.export.success',
            }),
            'toaster-success'
          ),
        error: () =>
          createTestIdToasterMessage(
            intl.formatMessage({
              id: 'articleVisibility.export.error',
            }),
            'toaster-error'
          ),
      });

      return promise;
    },
    [intl]
  );

  return { withDownloadProgress };
}
